import type { TopicItem } from "@/types/content";

export const topics: TopicItem[] = [
  {
    id: "t1",
    title: "黄金投资入门",
    subtitle: "从零开始认识黄金",
    description: "系统了解黄金的属性、交易规则与常见投资工具，为第一次配置黄金打好基础。",
    articleCount: 6,
    cover:
      "https://readdy.ai/api/search-image?query=Beginner%20gold%20investment%20guide%20editorial%20illustration%2C%20single%20glowing%20gold%20bar%20on%20a%20deep%20navy%20pedestal%20with%20warm%20light%2C%20minimal%20elegant%20financial%20style%2C%20high%20detail&width=800&height=600&seq=topic-01&orientation=landscape",
    accent: "primary",
    newsIds: ["n2", "n6", "n7"],
  },
  {
    id: "t2",
    title: "市场回顾",
    subtitle: "复盘行情演变脉络",
    description: "按月与季度复盘黄金价格走势，梳理驱动金价的关键变量与市场情绪变化。",
    articleCount: 8,
    cover:
      "https://readdy.ai/api/search-image?query=Gold%20market%20recap%20editorial%20illustration%2C%20multiple%20golden%20trend%20lines%20and%20charts%20layered%20on%20deep%20navy%20background%2C%20soft%20warm%20glow%2C%20minimal%20professional%20financial%20style&width=800&height=600&seq=topic-02&orientation=landscape",
    accent: "accent",
    newsIds: ["n5", "n1", "n9"],
  },
  {
    id: "t3",
    title: "政策与央行",
    subtitle: "读懂官方购金动向",
    description: "跟踪全球央行储备变化与相关政策动态，理解其对黄金中长期定价的影响。",
    articleCount: 5,
    cover:
      "https://readdy.ai/api/search-image?query=Central%20bank%20gold%20policy%20editorial%20illustration%2C%20a%20neat%20stack%20of%20gold%20bars%20with%20a%20subtle%20seal%20emblem%2C%20deep%20navy%20backdrop%2C%20warm%20golden%20rim%20light%2C%20minimal%20authoritative%20style&width=800&height=600&seq=topic-03&orientation=landscape",
    accent: "secondary",
    newsIds: ["n3", "n7", "n6"],
  },
  {
    id: "t4",
    title: "热点解读",
    subtitle: "快速理解突发事件",
    description: "针对地缘局势、汇率波动等突发变量，第一时间解读其对黄金价格的短期影响。",
    articleCount: 7,
    cover:
      "https://readdy.ai/api/search-image?query=Breaking%20news%20gold%20market%20editorial%20illustration%2C%20pulsing%20golden%20signal%20waves%20over%20a%20deep%20navy%20globe%2C%20warm%20neon%20gold%20accents%2C%20minimal%20modern%20financial%20style&width=800&height=600&seq=topic-04&orientation=landscape",
    accent: "primary",
    newsIds: ["n4", "n8", "n9"],
  },
];